import { Link } from '@tanstack/react-router';
import { CheckCircleIcon, FilterIcon } from 'lucide-react';
import { useNamespaceFilterStore } from '../../services/cloudflare';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';

export function HeaderLeft({ isAuthenticated }: { isAuthenticated: boolean }) {
  const { filterZeOnly, toggleZeFilter } = useNamespaceFilterStore();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center content-center gap-2">
        <Link to="/">
          <h1 className="text-lg font-bold text-primary">
            Cloudflare KV Viewer
          </h1>
        </Link>
        {isAuthenticated && (
          <div className="flex text-green-500 items-center gap-1">
            <CheckCircleIcon className="w-4 h-4 " />
            <p className="text-sm">Connected</p>
          </div>
        )}

        {isAuthenticated && (
          <div className="flex items-center ml-6 gap-2">
            <Checkbox
              id="ze-filter"
              checked={filterZeOnly}
              onCheckedChange={toggleZeFilter}
            />
            <Label
              htmlFor="ze-filter"
              className="text-sm flex items-center gap-1 cursor-pointer text-slate-300"
            >
              <FilterIcon className="w-3 h-3" />
              'ze' only
            </Label>
          </div>
        )}
      </div>
      <p className="text-sm text-muted-foreground">
        A secure tool to view and explore your Cloudflare KV namespaces
      </p>
    </div>
  );
}
